import { EException } from 'types/response-code/error-logger';

export const errorLoggerErrorMessageInfo: Record<EException, string> = {
  '-1': 'Vui lòng kiểm tra lại thông tin'
};
